export default "__VITE_ASSET__B0Mw9g8y__"